import {
  CURRENCY,
  Currency,
  FALLBACK_CURRENCY,
  LOCALE,
  Locale,
} from "@/constants";
import { useUser } from "@/hooks/useUser";
import { User } from "@/types/User";

import useSearchParams from "./useSearchParams";

const LANGUAGE_CURRENCY_MAP: Record<Locale, Currency> = {
  [LOCALE.ENGLISH]: CURRENCY.USD,
  [LOCALE.SWEDISH]: CURRENCY.SEK,
  // [LOCALE.NORWEGIAN]: CURRENCY.NOK // TODO: uncomment when/if we have norwegian
};

const useActiveCurrency = (language?: Locale): Currency => {
  // Try to get the user
  const { data } = useUser();
  const userCurrency = (data?.data as User)?.currency;

  // If there's no user, revert to using params
  const [{ currency: paramCurrency }] = useSearchParams<{
    currency?: Currency;
  }>();

  // return in order of priority
  return (
    userCurrency ||
    CURRENCY[paramCurrency?.toUpperCase() as Currency] ||
    // The language passed in as a fallback might be mappable to language. Let's use that as a last resort.
    (language ? LANGUAGE_CURRENCY_MAP[language] : undefined) ||
    FALLBACK_CURRENCY
  );
};

export default useActiveCurrency;
